import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function FormAnswersForbiddenAccessStateIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 251 250'
      fill='none'
    >
      <g filter='url(#filter0_i_8945_37031)'>
        <rect
          x='0.5'
          width='250'
          height='250'
          rx='125'
          fill='#F0F5FF'
        />
        <g filter='url(#filter1_d_8945_37031)'>
          <path
            d='M54.71 79C54.71 74.5817 58.2917 71 62.71 71H186.275C190.693 71 194.275 74.5817 194.275 79V159.375H54.71V79Z'
            fill='#2D6FD7'
          />
        </g>
        <rect
          x='62.9365'
          y='79.709'
          width='123.594'
          height='72.4042'
          rx='3.5'
          fill='white'
          stroke='#DFEAFB'
        />
        <g filter='url(#filter2_d_8945_37031)'>
          <path
            d='M46.5 160.098H202.001V166.387C202.001 170.805 198.419 174.387 194.001 174.387H54.5C50.0817 174.387 46.5 170.805 46.5 166.387V160.098Z'
            fill='#2D6FD7'
          />
        </g>
        <circle
          cx='124.251'
          cy='167.102'
          r='4.3463'
          fill='#3E8FFA'
        />
        <g filter='url(#filter3_d_8945_37031)'>
          <path
            d='M183.197 131.775C181.959 145.776 169.509 156.114 155.387 154.866C141.266 153.618 130.821 141.257 132.058 127.256C133.295 113.256 145.746 102.918 159.867 104.166C173.989 105.414 184.434 117.775 183.197 131.775Z'
            fill='#3E8FFA'
          />
        </g>
        <g filter='url(#filter4_d_8945_37031)'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M155.827 149.885C167.239 150.894 177.225 142.545 178.216 131.335C179.206 120.126 170.839 110.155 159.427 109.146C148.016 108.138 138.029 116.487 137.038 127.696C136.048 138.906 144.416 148.877 155.827 149.885ZM155.387 154.866C169.509 156.114 181.959 145.776 183.197 131.775C184.434 117.775 173.989 105.414 159.867 104.166C145.746 102.918 133.295 113.256 132.058 127.256C130.821 141.257 141.266 153.618 155.387 154.866Z'
            fill='#3E8FFA'
          />
        </g>
        <circle
          cx='157.421'
          cy='129.511'
          r='17.4808'
          transform='rotate(5.04987 157.421 129.511)'
          fill='#F0F5FF'
          stroke='#F0F5FF'
          strokeWidth='6'
        />
        <g filter='url(#filter5_d_8945_37031)'>
          <rect
            width='13.5226'
            height='8.49973'
            transform='matrix(0.793739 0.608258 -0.614451 0.788955 179.911 141.201)'
            fill='#3E8FFA'
          />
        </g>
        <g filter='url(#filter6_d_8945_37031)'>
          <rect
            width='30.5923'
            height='9.78887'
            rx='4.89443'
            transform='matrix(0.793739 0.608258 -0.614451 0.788955 188.741 147.016)'
            fill='#1F477D'
          />
          <rect
            x='0.438758'
            y='3.41929'
            width='25.6979'
            height='4.89443'
            rx='2.44722'
            transform='matrix(0.793739 0.608258 -0.614451 0.788955 190.933 147.47)'
            stroke='#1F477D'
            strokeWidth='4.89443'
          />
        </g>
        <rect
          width='4.31834'
          height='12.0197'
          rx='2.15917'
          transform='matrix(0.811987 0.583676 -0.589821 0.807534 190.663 147)'
          fill='#1F477D'
        />
        <path
          d='M189.277 148.941L184.829 154.966L183.31 152.625L186.723 147.769L189.277 148.941Z'
          fill='#3E8FFA'
        />
      </g>
      <defs>
        <filter
          id='filter0_i_8945_37031'
          x='0.5'
          y='0'
          width='259'
          height='270'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='BackgroundImageFix'
            result='shape'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='9'
            dy='25'
          />
          <feGaussianBlur stdDeviation='10' />
          <feComposite
            in2='hardAlpha'
            operator='arithmetic'
            k2='-1'
            k3='1'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.7275 0 0 0 0 0.810305 0 0 0 0 0.97 0 0 0 0.6 0'
          />
          <feBlend
            mode='normal'
            in2='shape'
            result='effect1_innerShadow_8945_37031'
          />
        </filter>
        <filter
          id='filter1_d_8945_37031'
          x='52.71'
          y='71'
          width='153.564'
          height='105.375'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='5'
            dy='10'
          />
          <feGaussianBlur stdDeviation='3.5' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.176471 0 0 0 0 0.435294 0 0 0 0 0.843137 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_8945_37031'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_8945_37031'
            result='shape'
          />
        </filter>
        <filter
          id='filter2_d_8945_37031'
          x='44.5'
          y='160.098'
          width='169.501'
          height='31.2891'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='5'
            dy='10'
          />
          <feGaussianBlur stdDeviation='3.5' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.176471 0 0 0 0 0.435294 0 0 0 0 0.843137 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_8945_37031'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_8945_37031'
            result='shape'
          />
        </filter>
        <filter
          id='filter3_d_8945_37031'
          x='129.958'
          y='104.064'
          width='65.3379'
          height='67.9043'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='5'
            dy='10'
          />
          <feGaussianBlur stdDeviation='3.5' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.176471 0 0 0 0 0.435294 0 0 0 0 0.843137 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_8945_37031'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_8945_37031'
            result='shape'
          />
        </filter>
        <filter
          id='filter4_d_8945_37031'
          x='129.958'
          y='104.064'
          width='65.3379'
          height='67.9043'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='5'
            dy='10'
          />
          <feGaussianBlur stdDeviation='3.5' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.176471 0 0 0 0 0.435294 0 0 0 0 0.843137 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_8945_37031'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_8945_37031'
            result='shape'
          />
        </filter>
        <filter
          id='filter5_d_8945_37031'
          x='172.688'
          y='141.201'
          width='29.9561'
          height='31.9316'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='5'
            dy='10'
          />
          <feGaussianBlur stdDeviation='3.5' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.176471 0 0 0 0 0.435294 0 0 0 0 0.843137 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_8945_37031'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_8945_37031'
            result='shape'
          />
        </filter>
        <filter
          id='filter6_d_8945_37031'
          x='182.705'
          y='148.979'
          width='40.3389'
          height='39.4062'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='5'
            dy='10'
          />
          <feGaussianBlur stdDeviation='3.5' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.176471 0 0 0 0 0.435294 0 0 0 0 0.843137 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_8945_37031'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_8945_37031'
            result='shape'
          />
        </filter>
      </defs>
    </SvgIcon>
  );
}
